// src/pages/CheckoutPage.jsx - PDF OLUŞTURMA KALDIRILMIŞ VERSİYON
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  ArrowLeft, CreditCard, MapPin, User, Phone, Mail,
  Home, Building, Check, Lock, Shield, Package, Truck,
  ChevronRight, AlertCircle, Plus, Trash2, FileText, Building2,
  UserCheck, UserPlus
} from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import { useSearch } from '../context/SearchContext';
import { openCartSidebar } from '../components/CartSidebar';
import { getUserAddresses, addAddress, deleteAddress } from '../services/customerService';
import { initiate3DPayment } from '../services/qnbPaymentService';
import { LegalModal } from '../components/LegalDocuments';
import { KVKKModal } from '../components/KVKKPolicy';
import toast from 'react-hot-toast';
import { getAllCampaigns, getFreeShippingCampaign } from '../services/discountService';
import { getAllProducts } from '../services/productService';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function CheckoutPage() {
  const navigate = useNavigate();
  const { items, cartCount, clearCart } = useCart();
  const { wishlistCount } = useWishlist();
  const { searchQuery, setSearchQuery } = useSearch();

  const [step, setStep] = useState(1);
  const [completedOrderNumber, setCompletedOrderNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingAddresses, setLoadingAddresses] = useState(true);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [useDifferentInvoiceAddress, setUseDifferentInvoiceAddress] = useState(false);
  const [invoiceAddress, setInvoiceAddress] = useState({
    fullName: '',
    phone: '',
    address: '',
    city: '',
    district: '',
    zipCode: ''
  });
  const [invoiceAddressErrors, setInvoiceAddressErrors] = useState({});
  const [freeShippingCampaign, setFreeShippingCampaign] = useState(null);

  const [isGuest, setIsGuest] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(true);
  const userId = localStorage.getItem('userId');
  const userName = localStorage.getItem('userName') || '';
  const userEmail = localStorage.getItem('userEmail') || '';
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  // Adres Form
  const [addressForm, setAddressForm] = useState({
    fullName: userName,
    phone: '',
    email: userEmail,
    addressTitle: '',
    addressLine: '',
    city: '',
    district: '',
    zipCode: '',
    addressType: 'home'
  });

  const [addressErrors, setAddressErrors] = useState({});

  // Ödeme Form
  const [paymentForm, setPaymentForm] = useState({
    cardNumber: '',
    cardName: '',
    expiryMonth: '',
    expiryYear: '',
    cvv: ''
  });

  const [paymentErrors, setPaymentErrors] = useState({});
  const [paymentMethod, setPaymentMethod] = useState('credit-card');

  // Kayıtlı adresler
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showAddressForm, setShowAddressForm] = useState(false);

  // ✨ YASAL BELGELER STATE'LERİ
  const [legalConsents, setLegalConsents] = useState({
    preInformation: false,
    distanceSales: false,
    kvkk: false
  });

  const [showLegalModal, setShowLegalModal] = useState({
    isOpen: false,
    type: null
  });

  // ✨ FATURA TİPİ VE KURUMSAL BİLGİLER
  const [invoiceType, setInvoiceType] = useState('individual'); // 'individual' veya 'corporate'
  const [corporateInfo, setCorporateInfo] = useState({
    companyName: '',
    taxNumber: '',
    taxOffice: '',
    corporateAddress: '',
    tcNo: '' // Bireysel fatura için TC kimlik no
  });
  const [corporateErrors, setCorporateErrors] = useState({});

  // Giriş ve adresleri yükle
  useEffect(() => {
    if (items.length === 0) {
      toast.error('Sepetinizde ürün yok');
      navigate('/cart');
      return;
    }

    // ✅ Giriş yapmış kullanıcı için adresleri yükle
    if (isLoggedIn && userId) {
      setIsGuest(false);
      setShowLoginPrompt(false);
      loadAddresses();
    } else {
      // ✅ Misafir kullanıcı
      setIsGuest(true);
      setShowLoginPrompt(true);
      setLoadingAddresses(false);
      setShowAddressForm(true); // Misafir için form açık
    }

    loadCampaignsAndProducts();
  }, [items, navigate, userId, isLoggedIn]);

  const loadCampaignsAndProducts = async () => {
    try {
      const [campaignsResult, productsResult, freeShippingResult] = await Promise.all([
        getAllCampaigns(),
        getAllProducts(),
        getFreeShippingCampaign(), // ✅ YENİ
      ]);

      // Sadece indirim kampanyalarını filtrele
      if (campaignsResult.success) {
        const discountCampaigns = campaignsResult.campaigns.filter(
          c => c.campaignType === 'discount' || !c.campaignType
        );
        setCampaigns(discountCampaigns);
      }

      // ✅ Ücretsiz kargo kampanyasını kaydet
      if (freeShippingResult.success && freeShippingResult.campaign) {
        setFreeShippingCampaign(freeShippingResult.campaign);
      }

      if (productsResult.success) {
        const activeProducts = productsResult.products.filter(product =>
          product.isActive !== false
        );
        setProducts(activeProducts);

        const categoriesSet = new Set();
        activeProducts.forEach(product => {
          if (product.category) {
            const mainCat = product.category.includes(' > ')
              ? product.category.split(' > ')[0]
              : product.category;
            categoriesSet.add(mainCat);
          }
        });
        setAvailableCategories(Array.from(categoriesSet));
      }
    } catch (error) {
      console.error('Kampanyalar yüklenirken hata:', error);
    }
  };

  const loadAddresses = async () => {
    try {
      const result = await getUserAddresses(userId);
      if (result.success) {
        setSavedAddresses(result.addresses);
      }
    } catch (error) {
      console.error('Adresler yüklenirken hata:', error);
    } finally {
      setLoadingAddresses(false);
    }
  };

  // ✨ MİSAFİR OLARAK DEVAM ET
  const handleContinueAsGuest = () => {
    setIsGuest(true);
    setShowLoginPrompt(false);
    setShowAddressForm(true);
    toast.success('Misafir olarak devam ediyorsunuz');
  };

  const handleAddressInputChange = (e) => {
    const { name, value } = e.target;
    setAddressForm(prev => ({ ...prev, [name]: value }));
    if (addressErrors[name]) {
      setAddressErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handlePaymentInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let formattedValue = value;

    if (name === 'cardNumber') {
      formattedValue = value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
      if (formattedValue.length > 19) return;
    }

    if (name === 'cvv') {
      formattedValue = value.replace(/\D/g, '').slice(0, 3);
    }

    if (name === 'expiryMonth') {
      formattedValue = value.replace(/\D/g, '').slice(0, 2);
      if (parseInt(formattedValue) > 12) formattedValue = '12';
    }

    if (name === 'expiryYear') {
      formattedValue = value.replace(/\D/g, '').slice(0, 2);
    }

    setPaymentForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : formattedValue
    }));

    if (paymentErrors[name]) {
      setPaymentErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // ✨ KURUMSAL BİLGİ FORM DEĞİŞİKLİĞİ
  const handleCorporateInfoChange = (e) => {
    const { name, value } = e.target;
    setCorporateInfo(prev => ({ ...prev, [name]: value }));
    if (corporateErrors[name]) {
      setCorporateErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateAddress = () => {
    const errors = {};

    if (!addressForm.fullName.trim()) errors.fullName = 'Ad Soyad zorunludur';
    if (!addressForm.phone.trim()) errors.phone = 'Telefon numarası zorunludur';
    if (!addressForm.email.trim()) errors.email = 'E-posta zorunludur';
    if (!addressForm.addressLine.trim()) errors.addressLine = 'Adres zorunludur';
    if (!addressForm.city.trim()) errors.city = 'Şehir zorunludur';
    if (!addressForm.district.trim()) errors.district = 'İlçe zorunludur';

    // Email format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (addressForm.email && !emailRegex.test(addressForm.email)) {
      errors.email = 'Geçerli bir e-posta adresi girin';
    }

    setAddressErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validatePayment = () => {
    if (paymentMethod === 'cash-on-delivery') return true;

    const errors = {};

    if (!paymentForm.cardNumber.replace(/\s/g, '')) errors.cardNumber = 'Kart numarası zorunludur';
    if (paymentForm.cardNumber.replace(/\s/g, '').length !== 16) errors.cardNumber = 'Geçerli bir kart numarası girin';
    if (!paymentForm.cardName.trim()) errors.cardName = 'Kart üzerindeki isim zorunludur';
    if (!paymentForm.expiryMonth) errors.expiryMonth = 'Ay zorunludur';
    if (!paymentForm.expiryYear) errors.expiryYear = 'Yıl zorunludur';
    if (!paymentForm.cvv) errors.cvv = 'CVV zorunludur';
    if (paymentForm.cvv.length !== 3) errors.cvv = 'CVV 3 haneli olmalıdır';

    setPaymentErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateCorporateInfo = () => {
    if (invoiceType === 'individual') {
      return true;
    }

    const errors = {};

    if (!corporateInfo.companyName.trim()) errors.companyName = 'Şirket ünvanı zorunludur';
    if (!corporateInfo.taxNumber.trim()) errors.taxNumber = 'Vergi numarası zorunludur';
    if (corporateInfo.taxNumber.length !== 10) errors.taxNumber = 'Vergi numarası 10 haneli olmalıdır';
    if (!corporateInfo.taxOffice.trim()) errors.taxOffice = 'Vergi dairesi zorunludur';
    if (!corporateInfo.corporateAddress.trim()) errors.corporateAddress = 'Şirket adresi zorunludur';

    setCorporateErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // calculateShippingCost fonksiyonundan ÖNCE bu fonksiyonları ekleyin:

  // Uygun ürünlere sahip kampanyalar
  const getCampaignsWithEligibleProducts = () => {
    return campaigns.filter(campaign => {
      const isActive = new Date(campaign.endDate) > new Date();
      if (!isActive) return false;

      // Sadece indirim kampanyaları
      if (campaign.campaignType === 'free_shipping') return false;

      return items.some(item => {
        if (campaign.targetCategory && campaign.targetCategory !== '') {
          return item.category === campaign.targetCategory;
        }
        if (campaign.targetProducts && campaign.targetProducts.length > 0) {
          return campaign.targetProducts.includes(item.id);
        }
        return true;
      });
    });
  };

  // Kampanyaya uygun ürünlerin toplam tutarını hesapla
  const getEligibleItemsTotal = (campaign) => {
    return items.reduce((sum, item) => {
      let isEligible = false;

      if (campaign.targetCategory && campaign.targetCategory !== '') {
        isEligible = item.category === campaign.targetCategory;
      } else if (campaign.targetProducts && campaign.targetProducts.length > 0) {
        isEligible = campaign.targetProducts.includes(item.id);
      } else {
        isEligible = true;
      }

      if (isEligible) {
        const itemPrice = item.currentPrice || item.price;
        return sum + (itemPrice * item.quantity);
      }
      return sum;
    }, 0);
  };

  // Uygulanabilir kampanyalar
  const getApplicableCampaigns = () => {
    return getCampaignsWithEligibleProducts().filter(campaign => {
      if (campaign.minPurchase) {
        const eligibleTotal = getEligibleItemsTotal(campaign);
        if (eligibleTotal < campaign.minPurchase) {
          return false;
        }
      }
      return true;
    });
  };

  const applicableCampaigns = getApplicableCampaigns();

  const bestCampaign = applicableCampaigns.length > 0
    ? applicableCampaigns.reduce((max, campaign) =>
      campaign.discountPercent > (max?.discountPercent || 0) ? campaign : max
    )
    : null;

  // Kampanya indirimi hesapla
  const calculateCampaignDiscount = () => {
    if (!bestCampaign) return 0;

    const eligibleItemsTotal = getEligibleItemsTotal(bestCampaign);
    return eligibleItemsTotal * (bestCampaign.discountPercent / 100);
  };

  const campaignDiscount = calculateCampaignDiscount();

  // Bu fonksiyonu bul ve tamamen değiştir:
  const calculateShippingCost = () => {
    const FREE_SHIPPING_THRESHOLD = freeShippingCampaign?.freeShippingThreshold || 0;
    const hasFreeShippingCampaign = freeShippingCampaign && FREE_SHIPPING_THRESHOLD > 0;

    // Ücretsiz kargo kampanyası varsa ve limit aşıldıysa
    if (hasFreeShippingCampaign && cartTotal >= FREE_SHIPPING_THRESHOLD) {
      return 0;
    }

    // Her ürünün kargo ücretini topla
    let totalShipping = 0;
    items.forEach(item => {
      const itemShipping = Number(item.shippingFee) || 0;
      totalShipping += itemShipping * item.quantity;
    });

    return totalShipping;
  };

  const rawCartTotal = items.reduce((sum, item) => {
    const itemPrice = item.currentPrice || item.price;
    return sum + (itemPrice * item.quantity);
  }, 0);

  const cartTotal = rawCartTotal - campaignDiscount;

  const shippingCost = calculateShippingCost();
  const finalTotal = cartTotal + shippingCost;

  const handleSaveNewAddress = async () => {
    if (!validateAddress()) {
      toast.error('Lütfen tüm alanları doldurun');
      return;
    }

    // ✅ MİSAFİR İÇİN: Adresi kaydetme, sadece doğrula
    if (isGuest) {
      toast.success('Adres bilgileri kaydedildi');
      setStep(2);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // ✅ ÜYE İÇİN: Adres kaydet
    setLoading(true);
    try {
      const result = await addAddress(userId, {
        title: addressForm.addressTitle || `${addressForm.addressType === 'home' ? 'Ev' : addressForm.addressType === 'work' ? 'İş' : 'Diğer'} Adresim`,
        fullName: addressForm.fullName,
        phone: addressForm.phone,
        email: addressForm.email,
        address: addressForm.addressLine,
        city: addressForm.city,
        district: addressForm.district,
        zipCode: addressForm.zipCode,
        type: addressForm.addressType
      });

      if (result.success) {
        toast.success('Adres kaydedildi');
        setSavedAddresses(prev => [...prev, result.address]);
        setSelectedAddress(result.address);
        setShowAddressForm(false);
      } else {
        toast.error('Adres kaydedilemedi');
      }
    } catch (error) {
      console.error(error);
      toast.error('Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    if (!window.confirm('Bu adresi silmek istediğinize emin misiniz?')) return;

    try {
      const result = await deleteAddress(userId, addressId);
      if (result.success) {
        toast.success('Adres silindi');
        setSavedAddresses(prev => prev.filter(addr => addr.id !== addressId));
        if (selectedAddress?.id === addressId) {
          setSelectedAddress(null);
        }
      } else {
        toast.error('Adres silinemedi');
      }
    } catch (error) {
      console.error(error);
      toast.error('Bir hata oluştu');
    }
  };

  const handleContinueToPayment = () => {
    // ✅ MİSAFİR İÇİN
    if (isGuest) {
      if (!validateAddress()) {
        toast.error('Lütfen adres bilgilerini eksiksiz doldurun');
        return;
      }
      setStep(2);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // ✅ ÜYE İÇİN
    if (!selectedAddress && !showAddressForm) {
      toast.error('Lütfen bir teslimat adresi seçin veya yeni adres ekleyin');
      return;
    }

    if (showAddressForm) {
      handleSaveNewAddress();
      return;
    }

    setStep(2);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ✅ 2. Handler fonksiyon ekle
  const handleInvoiceAddressChange = (e) => {
    const { name, value } = e.target;
    setInvoiceAddress(prev => ({ ...prev, [name]: value }));
    if (invoiceAddressErrors[name]) {
      setInvoiceAddressErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // ✅ 3. Validasyon fonksiyonu ekle
  const validateInvoiceAddress = () => {
    if (!useDifferentInvoiceAddress) return true; // Farklı adres kullanılmıyorsa geç

    const errors = {};

    if (!invoiceAddress.fullName.trim()) errors.fullName = 'Ad Soyad zorunludur';
    if (!invoiceAddress.phone.trim()) errors.phone = 'Telefon numarası zorunludur';
    if (!invoiceAddress.address.trim()) errors.address = 'Adres zorunludur';
    if (!invoiceAddress.city.trim()) errors.city = 'Şehir zorunludur';
    if (!invoiceAddress.district.trim()) errors.district = 'İlçe zorunludur';

    setInvoiceAddressErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePlaceOrder = async () => {
  // Yasal onay kontrolü
  if (!legalConsents.preInformation || !legalConsents.distanceSales || !legalConsents.kvkk) {
    toast.error('Lütfen tüm sözleşmeleri okuyup onaylayın', { duration: 4000 });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  // Ödeme kontrolü
  if (!validatePayment()) {
    toast.error('Lütfen ödeme bilgilerini kontrol edin');
    return;
  }

  // Adres kontrolü
  if (isGuest) {
    if (!validateAddress()) {
      toast.error('Lütfen adres bilgilerini kontrol edin');
      setStep(1);
      return;
    }
  } else {
    if (!selectedAddress) {
      toast.error('Lütfen bir teslimat adresi seçin');
      setStep(1);
      return;
    }
  }

  // Kurumsal bilgi kontrolü
  if (!validateCorporateInfo()) {
    toast.error('Lütfen fatura bilgilerini eksiksiz doldurun');
    return;
  }

  // Fatura adresi kontrolü
  if (!validateInvoiceAddress()) {
    toast.error('Lütfen fatura adresi bilgilerini kontrol edin');
    return;
  }

  setLoading(true);

  try {
    const orderId = `ORD-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

    console.log('💳 Ödeme işlemi başlatılıyor...');

    // ==================== TESLİMAT ADRESİNİ HAZIRLA ====================
    let shippingAddress;

    if (isGuest) {
      const nameParts = addressForm.fullName.trim().split(' ');
      shippingAddress = {
        firstName: nameParts[0] || '',
        lastName: nameParts.slice(1).join(' ') || '',
        phone: addressForm.phone,
        email: addressForm.email,
        address: addressForm.addressLine,
        city: addressForm.city,
        district: addressForm.district,
        zipCode: addressForm.zipCode
      };
    } else {
      shippingAddress = {
        firstName: selectedAddress.firstName || userName.split(' ')[0],
        lastName: selectedAddress.lastName || userName.split(' ')[1] || '',
        phone: selectedAddress.phone || '',
        email: userEmail || selectedAddress.email,
        address: selectedAddress.address || '',
        city: selectedAddress.city || '',
        district: selectedAddress.district || '',
        zipCode: selectedAddress.zipCode || ''
      };
    }

    // ==================== FATURA ADRESİ ====================
    let finalInvoiceAddress;

    if (useDifferentInvoiceAddress && invoiceAddress) {
      const invoiceNameParts = (invoiceAddress.fullName || '').trim().split(' ');
      finalInvoiceAddress = {
        firstName: invoiceNameParts[0] || shippingAddress.firstName,
        lastName: invoiceNameParts.slice(1).join(' ') || shippingAddress.lastName,
        phone: invoiceAddress.phone || shippingAddress.phone,
        address: invoiceAddress.address || shippingAddress.address,
        city: invoiceAddress.city || shippingAddress.city,
        district: invoiceAddress.district || shippingAddress.district,
        zipCode: invoiceAddress.zipCode || shippingAddress.zipCode
      };
    } else {
      finalInvoiceAddress = { ...shippingAddress };
    }

    // ==================== SİPARİŞ VERİSİ ====================
    const orderData = {
      orderId: orderId,
      orderNumber: orderId,
      customerId: isGuest ? 'guest' : userId,
      customerType: isGuest ? 'guest' : 'member',
      email: shippingAddress.email,
      shippingAddress: shippingAddress,
      paymentMethod: 'credit-card',
      paymentStatus: 'pending',
      items: items.map(item => ({
        productId: item.id,
        productName: item.name,
        productImage: item.image,
        price: item.price,
        quantity: item.quantity,
        shippingFee: Number(item.shippingFee) || 0
      })),
      subtotal: cartTotal,
      shippingCost: shippingCost,
      total: finalTotal,
      invoiceType: invoiceType,
      invoiceInfo: invoiceType === 'corporate'
        ? {
          companyName: corporateInfo.companyName,
          taxNumber: corporateInfo.taxNumber,
          taxOffice: corporateInfo.taxOffice
        }
        : {
          tcNo: corporateInfo.tcNo || '11111111110'
        },
      useDifferentInvoiceAddress: useDifferentInvoiceAddress,
      invoiceAddress: finalInvoiceAddress,
      legalConsents: {
        kvkk: { accepted: true, acceptedAt: new Date().toISOString() },
        preInformation: { accepted: true, acceptedAt: new Date().toISOString() },
        distanceSales: { accepted: true, acceptedAt: new Date().toISOString() }
      }
    };

    console.log('📦 Sipariş verisi hazırlandı:', {
      orderId: orderData.orderId,
      invoiceType: orderData.invoiceType,
      useDifferentInvoiceAddress: orderData.useDifferentInvoiceAddress
    });

    // ✅ Sipariş verisini localStorage'a kaydet
    localStorage.setItem('pendingOrder', JSON.stringify(orderData));

    // ✅ QNB 3D Pay ile ödeme başlat
    const paymentData = {
      cardNumber: paymentForm.cardNumber.replace(/\s/g, ''),
      cardName: paymentForm.cardName,
      expiryMonth: paymentForm.expiryMonth,
      expiryYear: paymentForm.expiryYear,
      cvv: paymentForm.cvv,
      amount: finalTotal.toFixed(2),
      orderId: orderId,
      installmentCount: 0,
      shippingAddress: shippingAddress,
      invoiceType: invoiceType,
      invoiceInfo: orderData.invoiceInfo,
      invoiceAddress: finalInvoiceAddress
    };

    console.log('💳 QNB ödeme başlatılıyor...');

    const paymentResult = await initiate3DPayment(paymentData);

    if (!paymentResult.success) {
      throw new Error(paymentResult.error || 'Ödeme başlatılamadı');
    }

    console.log('✅ 3D Pay başlatıldı, yönlendiriliyor...');

    // ✅ 3D Secure sayfasına yönlendir
    const htmlContent = paymentResult.html;
    const paymentWindow = window.open('', '_self');
    paymentWindow.document.open();
    paymentWindow.document.write(htmlContent);
    paymentWindow.document.close();

  } catch (error) {
    console.error('💥 Ödeme hatası:', error);
    toast.error(error.message || 'Ödeme işlemi başlatılamadı');
    setLoading(false);
  }
};

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  if (step === 3) {
    return (
      <OrderSuccess finalTotal={finalTotal} orderNumber={completedOrderNumber} />
    );
  }

  return (
    <div className="checkout-page">
      <Style />

      {/* YASAL BELGELER MODAL */}
      {showLegalModal.type === 'kvkk' ? (
        <KVKKModal
          isOpen={showLegalModal.isOpen}
          onClose={() => setShowLegalModal({ isOpen: false, type: null })}
        />
      ) : (
        <LegalModal
          isOpen={showLegalModal.isOpen}
          type={showLegalModal.type}
          onClose={() => setShowLegalModal({ isOpen: false, type: null })}
        />
      )}

      <Header
        wishlistCount={wishlistCount}
        cartCount={cartCount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={handleSearch}
        onCartClick={openCartSidebar}
        onWishlistClick={() => navigate('/wishlist')}
        onCampaignsClick={() => navigate('/campaigns')}
        availableCategories={availableCategories}
        products={products}
      />

      <div className="container">
        <div className="breadcrumb">
          <Link to="/">Anasayfa</Link>
          <ChevronRight size={16} />
          <Link to="/cart">Sepetim</Link>
          <ChevronRight size={16} />
          <span>Ödeme</span>
        </div>

        {/* ✨ GİRİŞ / MİSAFİR SEÇİMİ */}
        {showLoginPrompt && (
          <div className="login-prompt-section">
            <div className="prompt-card">
              <h2>Nasıl devam etmek istersiniz?</h2>
              <p>Üye girişi yaparak avantajlardan yararlanın veya misafir olarak hızlıca alışverişinizi tamamlayın</p>

              <div className="choice-buttons">
                <Link to="/account" className="choice-option member-option">
                  <div className="option-icon">
                    <UserCheck size={32} />
                  </div>
                  <h3>Üye Girişi</h3>
                  <ul className="benefits-list">
                    <li>✓ Kayıtlı adreslerinizi kullanın</li>
                    <li>✓ Siparişlerinizi takip edin</li>
                    <li>✓ Hızlı ödeme yapın</li>
                    <li>✓ Kampanyalardan haberdar olun</li>
                  </ul>
                  <button className="action-btn primary-action">
                    Giriş Yap / Üye Ol
                  </button>
                </Link>

                <div className="choice-option guest-option" onClick={handleContinueAsGuest}>
                  <div className="option-icon">
                    <UserPlus size={32} />
                  </div>
                  <h3>Misafir Alışveriş</h3>
                  <ul className="benefits-list">
                    <li>✓ Hızlı ödeme</li>
                    <li>✓ Üyelik gerektirmez</li>
                    <li>✓ Tek sefere özel</li>
                    <li>✓ Güvenli alışveriş</li>
                  </ul>
                  <button className="action-btn secondary-action">
                    Misafir Olarak Devam Et
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✨ ADIM GÖSTERGESİ - Sadece devam edildiyse göster */}
        {!showLoginPrompt && (
          <>
            <div className="progress-steps">
              <div className={`progress-step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'completed' : ''}`}>
                <div className="step-circle">
                  {step > 1 ? <Check size={20} /> : <MapPin size={20} />}
                </div>
                <span>Teslimat Adresi</span>
              </div>
              <div className="progress-line"></div>
              <div className={`progress-step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'completed' : ''}`}>
                <div className="step-circle">
                  {step > 2 ? <Check size={20} /> : <CreditCard size={20} />}
                </div>
                <span>Ödeme Bilgileri</span>
              </div>
              <div className="progress-line"></div>
              <div className={`progress-step ${step >= 3 ? 'active' : ''}`}>
                <div className="step-circle">
                  <Check size={20} />
                </div>
                <span>Sipariş Onayı</span>
              </div>
            </div>

            <div className="checkout-layout">
              <div className="checkout-main">
                {/* Step 1: Address */}
                {step === 1 && (
                  <div className="checkout-section">
                    <div className="section-header">
                      <h2>
                        <MapPin size={24} />
                        Teslimat Adresi
                      </h2>
                      {isGuest && (
                        <span className="guest-badge">Misafir Kullanıcı</span>
                      )}
                    </div>

                    {loadingAddresses ? (
                      <div className="loading-addresses">
                        <div className="spinner"></div>
                        <p>Adresler yükleniyor...</p>
                      </div>
                    ) : (
                      <>
                        {/* ÜYE: Kayıtlı Adresler */}
                        {!isGuest && savedAddresses.length > 0 && !showAddressForm ? (
                          <div className="saved-addresses">
                            <h3>Kayıtlı Adreslerim</h3>
                            <div className="addresses-grid">
                              {savedAddresses.map(address => (
                                <div
                                  key={address.id}
                                  className={`address-card ${selectedAddress?.id === address.id ? 'selected' : ''}`}
                                  onClick={() => setSelectedAddress(address)}
                                >
                                  <div className="address-header">
                                    <div className="address-type">
                                      {address.type === 'home' ? <Home size={16} /> : <Building size={16} />}
                                      <span>{address.title}</span>
                                    </div>
                                    {selectedAddress?.id === address.id && (
                                      <div className="selected-badge">
                                        <Check size={14} />
                                      </div>
                                    )}
                                  </div>
                                  <div className="address-details">
                                    <p className="address-name">{address.fullName}</p>
                                    <p className="address-phone">{address.phone}</p>
                                    <p className="address-text">{address.address}</p>
                                    <p className="address-location">{address.district} / {address.city}</p>
                                  </div>
                                  <div className="address-actions">
                                    <button
                                      className="delete-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteAddress(address.id);
                                      }}
                                    >
                                      <Trash2 size={14} />
                                      Sil
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : !isGuest && !showAddressForm ? (
                          <div className="no-addresses">
                            <MapPin size={48} />
                            <h3>Kayıtlı Adresiniz Yok</h3>
                            <p>Devam etmek için yeni bir adres ekleyin</p>
                          </div>
                        ) : null}

                        {/* YENİ ADRES EKLE BUTONU - Sadece üyeler için */}
                        {!isGuest && !showAddressForm && (
                          <button
                            className="add-address-btn"
                            onClick={() => setShowAddressForm(true)}
                          >
                            <Plus size={20} />
                            Yeni Adres Ekle
                          </button>
                        )}

                        {/* ADRES FORMU - Hem üye hem misafir için */}
                        {showAddressForm && (
                          <div className="address-form">
                            <div className="form-header">
                              <h3>{isGuest ? 'Teslimat Bilgileri' : 'Yeni Adres Ekle'}</h3>
                              {!isGuest && savedAddresses.length > 0 && (
                                <button
                                  className="close-form-btn"
                                  onClick={() => setShowAddressForm(false)}
                                >
                                  ✕
                                </button>
                              )}
                            </div>

                            <div className="form-grid">
                              <div className="form-group">
                                <label htmlFor="fullName">Ad Soyad *</label>
                                <div className="input-wrapper">
                                  <User className="input-icon" size={18} />
                                  <input
                                    type="text"
                                    id="fullName"
                                    name="fullName"
                                    value={addressForm.fullName}
                                    onChange={handleAddressInputChange}
                                    placeholder="Adınız ve soyadınız"
                                    className={addressErrors.fullName ? 'error' : ''}
                                  />
                                </div>
                                {addressErrors.fullName && (
                                  <span className="error-text">{addressErrors.fullName}</span>
                                )}
                              </div>

                              <div className="form-group">
                                <label htmlFor="phone">Telefon *</label>
                                <div className="input-wrapper">
                                  <Phone className="input-icon" size={18} />
                                  <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={addressForm.phone}
                                    onChange={handleAddressInputChange}
                                    placeholder="0532 123 45 67"
                                    className={addressErrors.phone ? 'error' : ''}
                                  />
                                </div>
                                {addressErrors.phone && (
                                  <span className="error-text">{addressErrors.phone}</span>
                                )}
                              </div>

                              <div className="form-group full-width">
                                <label htmlFor="email">E-posta *</label>
                                <div className="input-wrapper">
                                  <Mail className="input-icon" size={18} />
                                  <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={addressForm.email}
                                    onChange={handleAddressInputChange}
                                    placeholder="ornek@email.com"
                                    className={addressErrors.email ? 'error' : ''}
                                  />
                                </div>
                                {addressErrors.email && (
                                  <span className="error-text">{addressErrors.email}</span>
                                )}
                              </div>

                              {!isGuest && (
                                <div className="form-group full-width">
                                  <label htmlFor="addressTitle">Adres Başlığı</label>
                                  <input
                                    type="text"
                                    id="addressTitle"
                                    name="addressTitle"
                                    value={addressForm.addressTitle}
                                    onChange={handleAddressInputChange}
                                    placeholder="Örn: Ev Adresim, İş Adresim"
                                  />
                                </div>
                              )}

                              <div className="form-group full-width">
                                <label htmlFor="addressLine">Adres *</label>
                                <textarea
                                  id="addressLine"
                                  name="addressLine"
                                  value={addressForm.addressLine}
                                  onChange={handleAddressInputChange}
                                  placeholder="Mahalle, sokak, bina no, daire no"
                                  rows="3"
                                  className={addressErrors.addressLine ? 'error' : ''}
                                />
                                {addressErrors.addressLine && (
                                  <span className="error-text">{addressErrors.addressLine}</span>
                                )}
                              </div>

                              <div className="form-group">
                                <label htmlFor="city">Şehir *</label>
                                <input
                                  type="text"
                                  id="city"
                                  name="city"
                                  value={addressForm.city}
                                  onChange={handleAddressInputChange}
                                  placeholder="Şehir"
                                  className={addressErrors.city ? 'error' : ''}
                                />
                                {addressErrors.city && (
                                  <span className="error-text">{addressErrors.city}</span>
                                )}
                              </div>

                              <div className="form-group">
                                <label htmlFor="district">İlçe *</label>
                                <input
                                  type="text"
                                  id="district"
                                  name="district"
                                  value={addressForm.district}
                                  onChange={handleAddressInputChange}
                                  placeholder="İlçe"
                                  className={addressErrors.district ? 'error' : ''}
                                />
                                {addressErrors.district && (
                                  <span className="error-text">{addressErrors.district}</span>
                                )}
                              </div>

                              <div className="form-group">
                                <label htmlFor="zipCode">Posta Kodu</label>
                                <input
                                  type="text"
                                  id="zipCode"
                                  name="zipCode"
                                  value={addressForm.zipCode}
                                  onChange={handleAddressInputChange}
                                  placeholder="07000"
                                />
                              </div>

                              {!isGuest && (
                                <div className="form-group">
                                  <label>Adres Tipi</label>
                                  <div className="address-type-selector">
                                    <button
                                      type="button"
                                      className={addressForm.addressType === 'home' ? 'active' : ''}
                                      onClick={() => setAddressForm(prev => ({ ...prev, addressType: 'home' }))}
                                    >
                                      <Home size={18} />
                                      Ev
                                    </button>
                                    <button
                                      type="button"
                                      className={addressForm.addressType === 'work' ? 'active' : ''}
                                      onClick={() => setAddressForm(prev => ({ ...prev, addressType: 'work' }))}
                                    >
                                      <Building size={18} />
                                      İş
                                    </button>
                                    <button
                                      type="button"
                                      className={addressForm.addressType === 'other' ? 'active' : ''}
                                      onClick={() => setAddressForm(prev => ({ ...prev, addressType: 'other' }))}
                                    >
                                      <MapPin size={18} />
                                      Diğer
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    <button
                      className="continue-btn"
                      onClick={handleContinueToPayment}
                      disabled={loading || loadingAddresses}
                    >
                      {loading ? (
                        <>
                          <div className="spinner-small"></div>
                          Kaydediliyor...
                        </>
                      ) : isGuest || showAddressForm ? (
                        <>
                          {isGuest ? 'Ödeme Bilgilerine Geç' : 'Adresi Kaydet ve Devam Et'}
                          <ChevronRight size={20} />
                        </>
                      ) : (
                        <>
                          Ödeme Bilgilerine Geç
                          <ChevronRight size={20} />
                        </>
                      )}
                    </button>
                  </div>
                )}

                {/* Step 2: Payment - FATURA TİPİ EKLENDİ */}
                {step === 2 && (
                  <div className="checkout-section">
                    <div className="section-header">
                      <h2>
                        <CreditCard size={24} />
                        Ödeme Bilgileri
                      </h2>
                    </div>

                    {/* ✨ FATURA TİPİ SEÇİMİ */}
                    <div className="invoice-type-section">
                      <h3>
                        <FileText size={20} />
                        Fatura Tipi
                      </h3>

                      <div className="invoice-type-selector">
                        <div
                          className={`invoice-type-card ${invoiceType === 'individual' ? 'selected' : ''}`}
                          onClick={() => setInvoiceType('individual')}
                        >
                          <div className="type-icon">
                            <User size={24} />
                          </div>
                          <div className="type-info">
                            <h4>Bireysel Fatura</h4>
                            <p>Şahıs adına fatura</p>
                          </div>
                          {invoiceType === 'individual' && (
                            <Check size={20} className="check-icon" />
                          )}
                        </div>

                        <div
                          className={`invoice-type-card ${invoiceType === 'corporate' ? 'selected' : ''}`}
                          onClick={() => setInvoiceType('corporate')}
                        >
                          <div className="type-icon">
                            <Building2 size={24} />
                          </div>
                          <div className="type-info">
                            <h4>Kurumsal Fatura</h4>
                            <p>Şirket adına fatura</p>
                          </div>
                          {invoiceType === 'corporate' && (
                            <Check size={20} className="check-icon" />
                          )}
                        </div>
                      </div>

                      {/* ✨ BİREYSEL FATURA - TC NO (OPSİYONEL) */}
                      {invoiceType === 'individual' && (
                        <div className="individual-info-form">
                          <div className="form-group">
                            <label htmlFor="tcNo">TC Kimlik No (Opsiyonel)</label>
                            <input
                              type="text"
                              id="tcNo"
                              name="tcNo"
                              value={corporateInfo.tcNo}
                              onChange={handleCorporateInfoChange}
                              placeholder="12345678901"
                              maxLength="11"
                            />
                            <small className="form-hint">Faturanızda TC Kimlik No görünmesini istiyorsanız girebilirsiniz.</small>
                          </div>
                        </div>
                      )}

                      {/* ✨ KURUMSAL FATURA FORMU */}
                      {invoiceType === 'corporate' && (
                        <div className="corporate-info-form">
                          <div className="form-grid">
                            <div className="form-group full-width">
                              <label htmlFor="companyName">Şirket Ünvanı *</label>
                              <input
                                type="text"
                                id="companyName"
                                name="companyName"
                                value={corporateInfo.companyName}
                                onChange={handleCorporateInfoChange}
                                placeholder="ABC Teknoloji A.Ş."
                                className={corporateErrors.companyName ? 'error' : ''}
                              />
                              {corporateErrors.companyName && (
                                <span className="error-text">{corporateErrors.companyName}</span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="taxNumber">Vergi Numarası *</label>
                              <input
                                type="text"
                                id="taxNumber"
                                name="taxNumber"
                                value={corporateInfo.taxNumber}
                                onChange={handleCorporateInfoChange}
                                placeholder="1234567890"
                                maxLength="10"
                                className={corporateErrors.taxNumber ? 'error' : ''}
                              />
                              {corporateErrors.taxNumber && (
                                <span className="error-text">{corporateErrors.taxNumber}</span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="taxOffice">Vergi Dairesi *</label>
                              <input
                                type="text"
                                id="taxOffice"
                                name="taxOffice"
                                value={corporateInfo.taxOffice}
                                onChange={handleCorporateInfoChange}
                                placeholder="Manavgat Vergi Dairesi"
                                className={corporateErrors.taxOffice ? 'error' : ''}
                              />
                              {corporateErrors.taxOffice && (
                                <span className="error-text">{corporateErrors.taxOffice}</span>
                              )}
                            </div>

                            <div className="form-group full-width">
                              <label htmlFor="corporateAddress">Şirket Adresi *</label>
                              <textarea
                                id="corporateAddress"
                                name="corporateAddress"
                                value={corporateInfo.corporateAddress}
                                onChange={handleCorporateInfoChange}
                                placeholder="Tam şirket adresi"
                                rows="3"
                                className={corporateErrors.corporateAddress ? 'error' : ''}
                              />
                              {corporateErrors.corporateAddress && (
                                <span className="error-text">{corporateErrors.corporateAddress}</span>
                              )}
                            </div>
                          </div>

                          <div className="corporate-info-notice">
                            <AlertCircle size={16} />
                            <span>Faturanız, girdiğiniz şirket bilgileri ile oluşturulacaktır.</span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* ✨ FATURA ADRESİ FARKLI MI? */}
                    <div className="invoice-address-section">
                      <div className="checkbox-option">
                        <label className="checkbox-label-modern">
                          <input
                            type="checkbox"
                            checked={useDifferentInvoiceAddress}
                            onChange={(e) => {
                              setUseDifferentInvoiceAddress(e.target.checked);
                              // Checkbox işaretlendiğinde teslimat adresini kopyala
                              if (e.target.checked && !isGuest && selectedAddress) {
                                setInvoiceAddress({
                                  fullName: selectedAddress.fullName || userName,
                                  phone: selectedAddress.phone || '',
                                  address: selectedAddress.address || '',
                                  city: selectedAddress.city || '',
                                  district: selectedAddress.district || '',
                                  zipCode: selectedAddress.zipCode || ''
                                });
                              } else if (e.target.checked && isGuest) {
                                setInvoiceAddress({
                                  fullName: addressForm.fullName,
                                  phone: addressForm.phone,
                                  address: addressForm.addressLine,
                                  city: addressForm.city,
                                  district: addressForm.district,
                                  zipCode: addressForm.zipCode
                                });
                              }
                            }}
                            className="checkbox-input"
                          />
                          <div className="checkbox-content">
                            <div className="checkbox-icon">
                              {useDifferentInvoiceAddress ? (
                                <Check size={16} />
                              ) : (
                                <div className="checkbox-empty"></div>
                              )}
                            </div>
                            <div className="checkbox-text-wrapper">
                              <span className="checkbox-title">Fatura adresim teslimat adresimden farklı</span>
                              <span className="checkbox-description">
                                Faturanızın farklı bir adrese gönderilmesini istiyorsanız işaretleyin
                              </span>
                            </div>
                          </div>
                        </label>
                      </div>

                      {/* ✨ FATURA ADRESİ FORMU */}
                      {useDifferentInvoiceAddress && (
                        <div className="invoice-address-form">
                          <div className="form-header-small">
                            <h4>📍 Fatura Adresi Bilgileri</h4>
                            <p>Faturanızın gönderileceği adresi girin</p>
                          </div>

                          <div className="form-grid">
                            <div className="form-group">
                              <label htmlFor="invoiceFullName">Ad Soyad *</label>
                              <div className="input-wrapper">
                                <User className="input-icon" size={18} />
                                <input
                                  type="text"
                                  id="invoiceFullName"
                                  name="fullName"
                                  value={invoiceAddress.fullName}
                                  onChange={handleInvoiceAddressChange}
                                  placeholder="Fatura adresindeki ad soyad"
                                  className={invoiceAddressErrors.fullName ? 'error' : ''}
                                />
                              </div>
                              {invoiceAddressErrors.fullName && (
                                <span className="error-text">{invoiceAddressErrors.fullName}</span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="invoicePhone">Telefon *</label>
                              <div className="input-wrapper">
                                <Phone className="input-icon" size={18} />
                                <input
                                  type="tel"
                                  id="invoicePhone"
                                  name="phone"
                                  value={invoiceAddress.phone}
                                  onChange={handleInvoiceAddressChange}
                                  placeholder="0532 123 45 67"
                                  className={invoiceAddressErrors.phone ? 'error' : ''}
                                />
                              </div>
                              {invoiceAddressErrors.phone && (
                                <span className="error-text">{invoiceAddressErrors.phone}</span>
                              )}
                            </div>

                            <div className="form-group full-width">
                              <label htmlFor="invoiceAddress">Adres *</label>
                              <textarea
                                id="invoiceAddress"
                                name="address"
                                value={invoiceAddress.address}
                                onChange={handleInvoiceAddressChange}
                                placeholder="Mahalle, sokak, bina no, daire no"
                                rows="3"
                                className={invoiceAddressErrors.address ? 'error' : ''}
                              />
                              {invoiceAddressErrors.address && (
                                <span className="error-text">{invoiceAddressErrors.address}</span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="invoiceCity">Şehir *</label>
                              <input
                                type="text"
                                id="invoiceCity"
                                name="city"
                                value={invoiceAddress.city}
                                onChange={handleInvoiceAddressChange}
                                placeholder="Şehir"
                                className={invoiceAddressErrors.city ? 'error' : ''}
                              />
                              {invoiceAddressErrors.city && (
                                <span className="error-text">{invoiceAddressErrors.city}</span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="invoiceDistrict">İlçe *</label>
                              <input
                                type="text"
                                id="invoiceDistrict"
                                name="district"
                                value={invoiceAddress.district}
                                onChange={handleInvoiceAddressChange}
                                placeholder="İlçe"
                                className={invoiceAddressErrors.district ? 'error' : ''}
                              />
                              {invoiceAddressErrors.district && (
                                <span className="error-text">{invoiceAddressErrors.district}</span>
                              )}
                            </div>

                            <div className="form-group">
                              <label htmlFor="invoiceZipCode">Posta Kodu</label>
                              <input
                                type="text"
                                id="invoiceZipCode"
                                name="zipCode"
                                value={invoiceAddress.zipCode}
                                onChange={handleInvoiceAddressChange}
                                placeholder="07000"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Payment Method Selection */}
                    <div className="payment-methods-selector">
                      <div
                        className={`payment-method-card ${paymentMethod === 'credit-card' ? 'selected' : ''}`}
                        onClick={() => setPaymentMethod('credit-card')}
                      >
                        <div className="method-icon">
                          <CreditCard size={24} />
                        </div>
                        <div className="method-info">
                          <h4>Kredi/Banka Kartı</h4>
                          <p>Güvenli ödeme</p>
                        </div>
                        {paymentMethod === 'credit-card' && (
                          <Check size={20} className="check-icon" />
                        )}
                      </div>
                    </div>

                    {/* Credit Card Form */}
                    {paymentMethod === 'credit-card' && (
                      <div className="payment-form">
                        <div className="form-grid">
                          <div className="form-group full-width">
                            <label htmlFor="cardNumber">Kart Numarası *</label>
                            <div className="input-wrapper">
                              <CreditCard className="input-icon" size={18} />
                              <input
                                type="text"
                                id="cardNumber"
                                name="cardNumber"
                                value={paymentForm.cardNumber}
                                onChange={handlePaymentInputChange}
                                placeholder="1234 5678 9012 3456"
                                className={paymentErrors.cardNumber ? 'error' : ''}
                              />
                            </div>
                            {paymentErrors.cardNumber && (
                              <span className="error-text">{paymentErrors.cardNumber}</span>
                            )}
                          </div>

                          <div className="form-group full-width">
                            <label htmlFor="cardName">Kart Üzerindeki İsim *</label>
                            <div className="input-wrapper">
                              <User className="input-icon" size={18} />
                              <input
                                type="text"
                                id="cardName"
                                name="cardName"
                                value={paymentForm.cardName}
                                onChange={handlePaymentInputChange}
                                placeholder="AD SOYAD"
                                className={paymentErrors.cardName ? 'error' : ''}
                              />
                            </div>
                            {paymentErrors.cardName && (
                              <span className="error-text">{paymentErrors.cardName}</span>
                            )}
                          </div>

                          <div className="form-group">
                            <label htmlFor="expiryMonth">Son Kullanma Tarihi *</label>
                            <div className="expiry-inputs">
                              <input
                                type="text"
                                id="expiryMonth"
                                name="expiryMonth"
                                value={paymentForm.expiryMonth}
                                onChange={handlePaymentInputChange}
                                placeholder="MM"
                                maxLength="2"
                                className={paymentErrors.expiryMonth ? 'error' : ''}
                              />
                              <span>/</span>
                              <input
                                type="text"
                                name="expiryYear"
                                value={paymentForm.expiryYear}
                                onChange={handlePaymentInputChange}
                                placeholder="YY"
                                maxLength="2"
                                className={paymentErrors.expiryYear ? 'error' : ''}
                              />
                            </div>
                            {(paymentErrors.expiryMonth || paymentErrors.expiryYear) && (
                              <span className="error-text">
                                {paymentErrors.expiryMonth || paymentErrors.expiryYear}
                              </span>
                            )}
                          </div>

                          <div className="form-group">
                            <label htmlFor="cvv">CVV *</label>
                            <div className="input-wrapper">
                              <Lock className="input-icon" size={18} />
                              <input
                                type="text"
                                id="cvv"
                                name="cvv"
                                value={paymentForm.cvv}
                                onChange={handlePaymentInputChange}
                                placeholder="123"
                                maxLength="3"
                                className={paymentErrors.cvv ? 'error' : ''}
                              />
                            </div>
                            {paymentErrors.cvv && (
                              <span className="error-text">{paymentErrors.cvv}</span>
                            )}
                          </div>
                        </div>

                        <div className="security-notice">
                          <Shield size={20} />
                          <div>
                            <h4>Güvenli Ödeme</h4>
                            <p>Ödeme bilgileriniz 256-bit SSL şifrelemesi ile korunmaktadır.</p>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="checkout-actions">
                      <button
                        className="back-btn"
                        onClick={() => setStep(1)}
                      >
                        <ArrowLeft size={20} />
                        Geri Dön
                      </button>
                      <button
                        className="continue-btn"
                        onClick={handlePlaceOrder}
                        disabled={loading || !legalConsents.preInformation || !legalConsents.distanceSales || !legalConsents.kvkk}
                      >
                        {loading ? (
                          <>
                            <div className="spinner-small"></div>
                            İşleniyor...
                          </>
                        ) : (
                          <>
                            Siparişi Tamamla
                            <ChevronRight size={20} />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Order Summary Sidebar */}
              <div className="order-summary-sidebar">
                {/* ✅ Sadece kampanya varsa ve henüz kazanılmadıysa göster */}
                {freeShippingCampaign && cartTotal < freeShippingCampaign.freeShippingThreshold && (
                  <div className="shipping-threshold-info">
                    <Truck size={16} />
                    <p>
                      <strong>{freeShippingCampaign.title || 'Ücretsiz Kargo'}</strong> için{' '}
                      <strong>{(freeShippingCampaign.freeShippingThreshold - cartTotal).toFixed(2)}₺</strong> daha ekleyin!
                    </p>
                  </div>
                )}

                <div className="summary-card">
                  <h3>Sipariş Özeti</h3>

                  <div className="summary-items">
                    {items.slice(0, 3).map(item => (
                      <div key={item.id} className="summary-item">
                        <img src={item.image} alt={item.name} />
                        <div className="item-info">
                          <p>{item.name}</p>
                          <span>{item.quantity} x {item.price.toFixed(2)}₺</span>
                        </div>
                      </div>
                    ))}
                    {items.length > 3 && (
                      <p className="more-items">+{items.length - 3} ürün daha</p>
                    )}
                  </div>

                  <div className="summary-details">
                    <div className="summary-row">
                      <span>Ara Toplam</span>
                      <span>{cartTotal.toFixed(2)}₺</span>
                    </div>
                    {/* ✅ KARGO SATIRI - Her zaman göster */}
                    <div className="summary-row">
                      <span>Kargo</span>
                      <span className={freeShippingCampaign && shippingCost === 0 ? 'free' : ''}>
                        {freeShippingCampaign && shippingCost === 0 ? 'Ücretsiz' : `${shippingCost.toFixed(2)}₺`}
                      </span>
                    </div>
                    <div className="summary-row total">
                      <span>Toplam</span>
                      <span>{finalTotal.toFixed(2)}₺</span>
                    </div>
                  </div>

                  {/* ✅ Sadece kampanya varsa ve kazanıldıysa göster */}
                  {freeShippingCampaign && shippingCost === 0 && cartTotal >= freeShippingCampaign.freeShippingThreshold && (
                    <div className="free-shipping-badge">
                      <Truck size={16} />
                      <span>{freeShippingCampaign.title || 'Ücretsiz Kargo'} Kazandınız!</span>
                    </div>
                  )}
                </div>

                <div className="trust-badges">
                  <div className="trust-badge">
                    <Shield size={20} />
                    <span>Güvenli Ödeme</span>
                  </div>
                  <div className="trust-badge">
                    <Truck size={20} />
                    <span>Hızlı Teslimat</span>
                  </div>
                  <div className="trust-badge">
                    <Package size={20} />
                    <span>Kolay İade</span>
                  </div>
                </div>

                {/* YASAL ONAYLAR */}
                <div className="legal-consents-sidebar">
                  <div className="sidebar-section-header">
                    <FileText size={18} />
                    <h4>Sözleşmeler ve Onaylar</h4>
                  </div>

                  <div className="legal-consent-item kvkk-item">
                    <label className="consent-checkbox-label">
                      <input
                        type="checkbox"
                        checked={legalConsents.kvkk}
                        onChange={(e) => setLegalConsents(prev => ({
                          ...prev,
                          kvkk: e.target.checked
                        }))}
                        className="consent-checkbox"
                      />
                      <span className="consent-text">
                        <button
                          type="button"
                          className="legal-link"
                          onClick={() => setShowLegalModal({ isOpen: true, type: 'kvkk' })}
                        >
                          KVKK Aydınlatma Metni
                        </button>
                        'ni okudum, kişisel verilerimin işlenmesine izin veriyorum *
                      </span>
                    </label>
                  </div>

                  <div className="legal-consent-item">
                    <label className="consent-checkbox-label">
                      <input
                        type="checkbox"
                        checked={legalConsents.preInformation}
                        onChange={(e) => setLegalConsents(prev => ({
                          ...prev,
                          preInformation: e.target.checked
                        }))}
                        className="consent-checkbox"
                      />
                      <span className="consent-text">
                        <button
                          type="button"
                          className="legal-link"
                          onClick={() => setShowLegalModal({ isOpen: true, type: 'pre-information' })}
                        >
                          Ön Bilgilendirme Formu
                        </button>
                        'nu okudum *
                      </span>
                    </label>
                  </div>

                  <div className="legal-consent-item">
                    <label className="consent-checkbox-label">
                      <input
                        type="checkbox"
                        checked={legalConsents.distanceSales}
                        onChange={(e) => setLegalConsents(prev => ({
                          ...prev,
                          distanceSales: e.target.checked
                        }))}
                        className="consent-checkbox"
                      />
                      <span className="consent-text">
                        <button
                          type="button"
                          className="legal-link"
                          onClick={() => setShowLegalModal({ isOpen: true, type: 'distance-sales' })}
                        >
                          Mesafeli Satış Sözleşmesi
                        </button>
                        'ni okudum *
                      </span>
                    </label>
                  </div>

                  <div className="cayma-hakki-info">
                    <AlertCircle size={14} />
                    <span>7 gün cayma hakkınız vardır</span>
                  </div>

                  {(!legalConsents.preInformation || !legalConsents.distanceSales || !legalConsents.kvkk) && (
                    <div className="legal-warning-sidebar">
                      <AlertCircle size={16} />
                      <span>Tüm sözleşmeleri onaylamanız gerekiyor</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

function OrderSuccess({ finalTotal, orderNumber }) {
  const navigate = useNavigate();

  if (!orderNumber) {
    navigate('/');
    return null;
  }

  return (
    <div className="order-success-page">
      <Style />
      <div className="container">
        <div className="success-content">
          <div className="success-icon-wrapper">
            <div className="success-icon-circle">
              <Check size={80} />
            </div>
            <div className="success-checkmark"></div>
          </div>

          <h1 className="success-title">Siparişiniz Alındı! 🎉</h1>

          <div className="order-number-box">
            <span className="order-label">Sipariş Numaranız</span>
            <strong className="order-number">{orderNumber}</strong>
          </div>

          <div className="success-message-box">
            <div className="message-icon">
              <Package size={24} />
            </div>
            <div className="message-content">
              <h3>Siparişiniz Alındı</h3>
              <p>
                Siparişiniz bizlere ulaştı.
                En kısa sürede hazırlanmaya başlanacaktır.
              </p>
            </div>
          </div>

          <div className="email-info-boxes">
            <div className="info-card">
              <div className="info-icon email-icon">
                <Mail size={24} />
              </div>
              <div className="info-text">
                <h4>Sipariş Onayı</h4>
                <p>E-posta adresinize gönderildi</p>
              </div>
            </div>
            <div className="info-card">
              <div className="info-icon invoice-icon">
                <FileText size={24} />
              </div>
              <div className="info-text">
                <h4>Fatura Bilgileri</h4>
                <p>E-posta adresinize gönderildi</p>
              </div>
            </div>
          </div>

          <div className="order-total-summary">
            <div className="total-row">
              <span>Ödenen Tutar</span>
              <strong className="total-amount">{finalTotal.toFixed(2)} ₺</strong>
            </div>
          </div>

          <div className="success-actions">
            <button className="primary-action-btn" onClick={() => navigate('/orders')}>
              <Package size={20} />
              Siparişlerimi Görüntüle
            </button>
            <button className="secondary-action-btn" onClick={() => navigate('/')}>
              Alışverişe Devam Et
            </button>
          </div>

          <div className="success-footer-info">
            <div className="footer-info-item">
              <Truck size={18} />
              <span>2-3 iş günü içinde kargoda</span>
            </div>
            <div className="footer-info-item">
              <Shield size={18} />
              <span>7 gün cayma hakkı</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// STYLES
function Style() {
  return <style>{`
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Inter', -apple-system, sans-serif; background: #f8f9fa; }
    
    .container { max-width: 1320px; margin: 0 auto; padding: 0 20px; }

    .checkout-page {
      min-height: 100vh;
    }

    .breadcrumb {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 20px 0;
      font-size: 14px;
    }
    .breadcrumb a {
      color: #868e96;
      text-decoration: none;
    }
    .breadcrumb a:hover {
      color: #E5332A;
    }

    .progress-steps {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 40px 0;
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
    }
    .progress-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    .step-circle {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #e9ecef;
      color: #868e96;
      transition: all 0.3s;
    }
    .progress-step.active .step-circle {
      background: #E5332A;
      color: #fff;
    }
    .progress-step.completed .step-circle {
      background: #22c55e;
      color: #fff;
    }
    .progress-step span {
      font-size: 14px;
      font-weight: 600;
      color: #868e96;
    }
    .progress-step.active span {
      color: #E5332A;
    }
    .progress-step.completed span {
      color: #22c55e;
    }
    .progress-line {
      flex: 1;
      height: 2px;
      background: #e9ecef;
      margin: 0 20px;
      max-width: 150px;
    }

    .checkout-layout {
      display: grid;
      grid-template-columns: 1fr 400px;
      gap: 32px;
      align-items: start;
    }

    .checkout-section {
      background: #fff;
      border-radius: 20px;
      padding: 32px;
      margin-bottom: 32px;
    }
    .section-header {
      margin-bottom: 32px;
    }
    .section-header h2 {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 24px;
    }

    .loading-addresses {
      text-align: center;
      padding: 60px 20px;
    }
    .spinner {
      width: 48px;
      height: 48px;
      border: 4px solid #e9ecef;
      border-top-color: #E5332A;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin: 0 auto 16px;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    .no-addresses {
      text-align: center;
      padding: 60px 20px;
      color: #868e96;
    }
    .no-addresses svg {
      margin-bottom: 16px;
    }
    .no-addresses h3 {
      font-size: 20px;
      margin-bottom: 8px;
      color: #2B2B2B;
    }

    .saved-addresses h3 {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .addresses-grid {
      display: grid;
      gap: 16px;
      margin-bottom: 24px;
    }
    .address-card {
      border: 2px solid #e9ecef;
      border-radius: 16px;
      padding: 20px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .address-card:hover {
      border-color: #E5332A;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.1);
    }
    .address-card.selected {
      border-color: #E5332A;
      background: #fff5f5;
    }
    .address-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }
    .address-type {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 600;
      color: #2B2B2B;
    }
    .selected-badge {
      width: 24px;
      height: 24px;
      background: #E5332A;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
    .address-details p {
      font-size: 14px;
      color: #495057;
      margin-bottom: 4px;
    }
    .address-name {
      font-weight: 600;
      color: #2B2B2B;
    }
    .address-actions {
      display: flex;
      gap: 12px;
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #e9ecef;
    }
    .delete-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      background: none;
      border: none;
      font-size: 13px;
      color: #868e96;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 6px;
    }
    .delete-btn:hover {
      background: #fff5f5;
      color: #dc3545;
    }

    .add-address-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      padding: 16px;
      background: #f8f9fa;
      border: 2px dashed #e9ecef;
      border-radius: 12px;
      font-weight: 600;
      color: #495057;
      cursor: pointer;
      transition: all 0.2s;
      margin-bottom: 24px;
    }
    .add-address-btn:hover {
      border-color: #E5332A;
      color: #E5332A;
      background: #fff5f5;
    }

    .address-form {
      background: #f8f9fa;
      border-radius: 16px;
      padding: 24px;
      margin-bottom: 24px;
    }
    .form-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
    }
    .form-header h3 {
      font-size: 18px;
    }
    .close-form-btn {
      background: none;
      border: none;
      font-size: 24px;
      color: #868e96;
      cursor: pointer;
      padding: 4px;
    }
    .close-form-btn:hover {
      color: #E5332A;
    }
    .form-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
    }
    .form-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .form-group.full-width {
      grid-column: 1 / -1;
    }
    .form-group label {
      font-size: 14px;
      font-weight: 600;
      color: #2B2B2B;
    }
    .input-wrapper {
      position: relative;
    }
    .input-wrapper input,
    .form-group input,
    .form-group textarea {
      width: 100%;
      padding: 12px;
      border: 2px solid #e9ecef;
      border-radius: 10px;
      font-size: 14px;
      transition: all 0.2s;
    }
    .input-wrapper input {
      padding-left: 40px;
    }
    .input-wrapper input:focus,
    .form-group input:focus,
    .form-group textarea:focus {
      outline: none;
      border-color: #E5332A;
      background: #fff;
    }
    .input-icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: #868e96;
    }
    .error-text {
      font-size: 13px;
      color: #dc3545;
    }
    input.error,
    textarea.error {
      border-color: #dc3545;
    }
    .address-type-selector {
      display: flex;
      gap: 12px;
    }
    .address-type-selector button {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      padding: 12px;
      background: #fff;
      border: 2px solid #e9ecef;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 13px;
    }
    .address-type-selector button:hover {
      border-color: #E5332A;
      color: #E5332A;
    }
    .address-type-selector button.active {
      background: #E5332A;
      border-color: #E5332A;
      color: #fff;
    }

    /* ✨ FATURA TİPİ SEÇİMİ STİLLERİ */
    .invoice-type-section {
      background: #f8f9fa;
      padding: 24px;
      border-radius: 16px;
      margin-bottom: 32px;
    }

    .invoice-type-section h3 {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 18px;
      margin-bottom: 20px;
      color: #2B2B2B;
    }

    .invoice-type-selector {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      margin-bottom: 24px;
    }

    .invoice-type-card {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px;
      background: #fff;
      border: 2px solid #e9ecef;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.2s;
      position: relative;
    }

    .invoice-type-card:hover {
      border-color: #E5332A;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.1);
    }

    .invoice-type-card.selected {
      border-color: #E5332A;
      background: #fff5f5;
    }

    .type-icon {
      width: 48px;
      height: 48px;
      background: #f8f9fa;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #E5332A;
    }

    .invoice-type-card.selected .type-icon {
      background: #E5332A;
      color: #fff;
    }

    .type-info h4 {
      font-size: 16px;
      margin-bottom: 4px;
      color: #2B2B2B;
    }

    .type-info p {
      font-size: 13px;
      color: #868e96;
    }

    .check-icon {
      position: absolute;
      top: 12px;
      right: 12px;
      color: #E5332A;
    }

    /* BİREYSEL FATURA FORMU */
    .individual-info-form {
      background: #fff;
      padding: 20px;
      border-radius: 12px;
      margin-top: 16px;
    }

    .form-hint {
      display: block;
      font-size: 12px;
      color: #868e96;
      margin-top: 6px;
      font-style: italic;
    }

    /* KURUMSAL FATURA FORMU */
    .corporate-info-form {
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      margin-top: 16px;
    }

    .corporate-info-notice {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #e3f2fd;
      padding: 12px;
      border-radius: 10px;
      margin-top: 16px;
      font-size: 13px;
      color: #1565c0;
    }

    .corporate-info-notice svg {
      color: #2196f3;
      flex-shrink: 0;
    }

    .payment-methods-selector {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      margin-bottom: 32px;
    }
    .payment-method-card {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px;
      border: 2px solid #e9ecef;
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.2s;
      position: relative;
    }
    .payment-method-card:hover {
      border-color: #E5332A;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.1);
    }
    .payment-method-card.selected {
      border-color: #E5332A;
      background: #fff5f5;
    }
    .method-icon {
      width: 48px;
      height: 48px;
      background: #f8f9fa;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #E5332A;
    }
    .method-info h4 {
      font-size: 16px;
      margin-bottom: 4px;
    }
    .method-info p {
      font-size: 13px;
      color: #868e96;
    }

    .payment-form {
      margin-bottom: 24px;
    }
    .expiry-inputs {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .expiry-inputs input {
      flex: 1;
      text-align: center;
    }
    .expiry-inputs span {
      font-size: 18px;
      font-weight: 600;
      color: #868e96;
    }

    .security-notice {
      display: flex;
      gap: 16px;
      background: #f0f9ff;
      border: 1px solid #bfdbfe;
      border-radius: 12px;
      padding: 16px;
      margin-top: 24px;
    }
    .security-notice svg {
      color: #3b82f6;
      flex-shrink: 0;
    }
    .security-notice h4 {
      font-size: 14px;
      margin-bottom: 4px;
    }
    .security-notice p {
      font-size: 13px;
      color: #64748b;
    }

    .checkout-actions {
      display: flex;
      gap: 16px;
      margin-top: 24px;
      align-items: center;
    }

    .back-btn,
    .continue-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 0 24px;
      background: #fff;
      border: 2px solid #e9ecef;
      border-radius: 12px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
      height: 52px;
      min-height: 52px;
      max-height: 52px;
      box-sizing: border-box;
      margin-top: 2px;
    }

    .back-btn {
      color: #495057;
      white-space: nowrap;
    }

    .back-btn:hover {
      border-color: #E5332A;
      color: #E5332A;
    }

    .continue-btn {
      flex: 1;
      background: #E5332A;
      border-color: #E5332A;
      color: #fff;
    }

    .continue-btn:hover:not(:disabled) {
      background: #c72a22;
      border-color: #c72a22;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
    }

    .continue-btn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .spinner-small {
      width: 18px;
      height: 18px;
      border: 2px solid rgba(255,255,255,0.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      flex-shrink: 0;
    }

    .order-summary-sidebar {
      position: sticky;
      top: 100px;
    }
    .summary-card {
      background: #fff;
      border-radius: 20px;
      padding: 24px;
      margin-bottom: 16px;
    }
    .summary-card h3 {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .summary-items {
      margin-bottom: 20px;
    }
    .summary-item {
      display: flex;
      gap: 12px;
      margin-bottom: 16px;
      background: #fff
    }
    .summary-item img {
      width: 60px;
      height: 60px;
      object-fit: contain;
    }
    .item-info {
      flex: 1;
    }
    .item-info p {
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 4px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .item-info span {
      font-size: 12px;
      color: #868e96;
    }
    .more-items {
      text-align: center;
      font-size: 13px;
      color: #868e96;
      padding: 8px;
      background: #f8f9fa;
      border-radius: 8px;
    }
    .summary-details {
      border-top: 1px solid #e9ecef;
      padding-top: 16px;
    }
    .summary-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 14px;
    }
    .summary-row .free {
      color: #22c55e;
      font-weight: 600;
    }
    .summary-row.total {
      font-size: 18px;
      font-weight: 700;
      margin-top: 16px;
      padding-top: 16px;
      border-top: 2px solid #e9ecef;
    }
    .free-shipping-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background: #dcfce7;
      color: #16a34a;
      padding: 12px;
      border-radius: 10px;
      font-size: 13px;
      font-weight: 600;
      margin-top: 16px;
    }
    .trust-badges {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 16px;
    }
    .trust-badge {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #fff;
      padding: 12px 16px;
      border-radius: 12px;
      font-size: 13px;
      font-weight: 600;
      color: #495057;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    }
    .trust-badge svg {
      color: #E5332A;
    }

    /* YASAL ONAYLAR SIDEBAR STİLLERİ */
    .legal-consents-sidebar {
      background: #fff;
      border-radius: 20px;
      padding: 20px;
      border: 2px solid #e9ecef;
      margin-bottom: 32px;
    }

    .sidebar-section-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 2px solid #f1f3f5;
    }

    .sidebar-section-header svg {
      color: #E5332A;
    }

    .sidebar-section-header h4 {
      font-size: 16px;
      font-weight: 700;
      color: #2B2B2B;
    }

    .legal-consent-item {
      background: #f8f9fa;
      padding: 12px;
      border-radius: 10px;
      margin-bottom: 12px;
      border: 2px solid #e9ecef;
      transition: all 0.2s;
    }

    .legal-consent-item:hover {
      border-color: #E5332A;
      box-shadow: 0 2px 8px rgba(229, 51, 42, 0.1);
    }

    .mobile-legal-section {
      display: none;
    }

    .desktop-legal-section {
  display: block;
}

.legal-consents-section {
  background: #fff5f5;
  border: 2px solid #E5332A;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
}

.legal-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #ffe0dd;
}

.legal-section-header svg {
  color: #E5332A;
}

.legal-section-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #2B2B2B;
}

.legal-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fff3e0;
  padding: 10px 12px;
  border-radius: 10px;
  border-left: 3px solid #ff9800;
}

.legal-warning svg {
  color: #ff9800;
  flex-shrink: 0;
  margin-top: 2px;
}

.legal-warning span {
  font-size: 12px;
  color: #e65100;
  font-weight: 500;
  line-height: 1.4;
}

    .consent-checkbox-label {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      cursor: pointer;
    }

    .consent-checkbox {
      width: 18px;
      height: 18px;
      cursor: pointer;
      flex-shrink: 0;
      margin-top: 2px;
      accent-color: #E5332A;
    }

    .consent-text {
      font-size: 13px;
      line-height: 1.5;
      color: #2B2B2B;
    }

    .legal-link {
      background: none;
      border: none;
      color: #E5332A;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
      padding: 0;
      font-size: inherit;
      transition: color 0.2s;
    }

    .legal-link:hover {
      color: #c72a22;
    }

    .cayma-hakki-info {
      display: flex;
      align-items: center;
      gap: 8px;
      background: #e3f2fd;
      padding: 10px 12px;
      border-radius: 10px;
      margin-bottom: 12px;
    }

    .cayma-hakki-info svg {
      color: #2196f3;
      flex-shrink: 0;
    }

    .cayma-hakki-info span {
      font-size: 12px;
      color: #1565c0;
      font-weight: 500;
    }

    .legal-warning-sidebar {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      background: #fff3e0;
      padding: 10px 12px;
      border-radius: 10px;
      border-left: 3px solid #ff9800;
    }

    .legal-warning-sidebar svg {
      color: #ff9800;
      flex-shrink: 0;
      margin-top: 2px;
    }

    .legal-warning-sidebar span {
      font-size: 12px;
      color: #e65100;
      font-weight: 500;
      line-height: 1.4;
    }

    .kvkk-item {
      background: #f0f9ff !important;
      border-color: #2196f3 !important;
    }

    .kvkk-item:hover {
      border-color: #1976d2 !important;
      box-shadow: 0 2px 8px rgba(33, 150, 243, 0.15) !important;
    }

    .order-success-page {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    }

    .success-content {
      background: #fff;
      border-radius: 32px;
      padding: 60px 50px;
      max-width: 700px;
      width: 100%;
      text-align: center;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
      animation: slideUpFade 0.6s ease-out;
    }

    @keyframes slideUpFade {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .success-icon-wrapper {
      position: relative;
      margin: 0 auto 40px;
      width: 140px;
      height: 140px;
    }

    .success-icon-circle {
      width: 140px;
      height: 140px;
      background: linear-gradient(135deg, #22c55e, #16a34a);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      position: relative;
      animation: scaleIn 0.5s ease-out 0.2s both;
      box-shadow: 0 10px 40px rgba(34, 197, 94, 0.3);
    }

    @keyframes scaleIn {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    .success-checkmark {
      position: absolute;
      width: 140px;
      height: 140px;
      border-radius: 50%;
      border: 4px solid #22c55e;
      opacity: 0;
      animation: pulse 1.5s ease-out 0.5s;
    }

    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(1.6);
        opacity: 0;
      }
    }

    .success-title {
      font-size: 36px;
      font-weight: 800;
      color: #2B2B2B;
      margin-bottom: 32px;
      line-height: 1.2;
    }

    .order-number-box {
      background: linear-gradient(135deg, #E5332A 0%, #c72a22 100%);
      padding: 24px 32px;
      border-radius: 16px;
      margin-bottom: 32px;
      box-shadow: 0 8px 24px rgba(229, 51, 42, 0.2);
    }

    .order-label {
      display: block;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      margin-bottom: 8px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .order-number {
      display: block;
      font-size: 32px;
      font-weight: 800;
      color: #fff;
      letter-spacing: 2px;
      font-family: 'Courier New', monospace;
    }

    .success-message-box {
      display: flex;
      gap: 20px;
      background: #f0f9ff;
      border: 2px solid #bfdbfe;
      border-radius: 16px;
      padding: 24px;
      margin-bottom: 32px;
      text-align: left;
      align-items: flex-start;
    }

    .message-icon {
      width: 48px;
      height: 48px;
      background: #3b82f6;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      flex-shrink: 0;
    }

    .message-content h3 {
      font-size: 18px;
      font-weight: 700;
      color: #1e3a8a;
      margin-bottom: 8px;
    }

    .message-content p {
      font-size: 15px;
      line-height: 1.6;
      color: #475569;
      margin: 0;
    }

    .email-info-boxes {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      margin-bottom: 32px;
    }

    .info-card {
      background: #f8f9fa;
      border: 2px solid #e9ecef;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      gap: 12px;
      align-items: center;
      text-align: left;
      transition: all 0.2s;
    }

    .info-card:hover {
      border-color: #E5332A;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.1);
      transform: translateY(-2px);
    }

    .info-icon {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      flex-shrink: 0;
    }

    .email-icon {
      background: linear-gradient(135deg, #3b82f6, #2563eb);
    }

    .invoice-icon {
      background: linear-gradient(135deg, #f59e0b, #d97706);
    }

    .info-text h4 {
      font-size: 14px;
      font-weight: 700;
      color: #2B2B2B;
      margin-bottom: 4px;
    }

    .info-text p {
      font-size: 13px;
      color: #868e96;
      margin: 0;
    }

    .order-total-summary {
      background: #f8f9fa;
      border-radius: 16px;
      padding: 24px;
      margin-bottom: 32px;
    }

    .total-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
    }

    .total-row span {
      color: #495057;
      font-weight: 600;
    }

    .total-amount {
      font-size: 32px;
      font-weight: 800;
      color: #E5332A;
    }

    .success-actions {
      display: flex;
      gap: 16px;
      margin-bottom: 32px;
    }

    .primary-action-btn,
    .secondary-action-btn {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 16px 24px;
      border-radius: 12px;
      font-weight: 700;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
    }

    .primary-action-btn {
      background: #E5332A;
      color: #fff;
    }

    .primary-action-btn:hover {
      background: #c72a22;
      box-shadow: 0 8px 20px rgba(229, 51, 42, 0.3);
      transform: translateY(-2px);
    }

    .secondary-action-btn {
      background: #fff;
      color: #495057;
      border: 2px solid #e9ecef;
    }

    .secondary-action-btn:hover {
      border-color: #E5332A;
      color: #E5332A;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .success-footer-info {
      display: flex;
      justify-content: center;
      gap: 32px;
      padding-top: 24px;
      border-top: 2px solid #e9ecef;
    }

    .footer-info-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #868e96;
      font-weight: 600;
    }

    .footer-info-item svg {
      color: #22c55e;
    }

    .login-prompt-section {
      padding: 60px 0;
    }

    .prompt-card {
      background: #fff;
      border-radius: 24px;
      padding: 48px;
      text-align: center;
      box-shadow: 0 4px 24px rgba(0,0,0,0.06);
    }

    .prompt-card h2 {
      font-size: 32px;
      margin-bottom: 16px;
      color: #2B2B2B;
    }

    .prompt-card > p {
      font-size: 16px;
      color: #868e96;
      margin-bottom: 48px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }

    .choice-buttons {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 32px;
      max-width: 1000px;
      margin: 0 auto;
    }

    .choice-option {
      background: #f8f9fa;
      border: 3px solid #e9ecef;
      border-radius: 20px;
      padding: 40px 32px;
      cursor: pointer;
      transition: all 0.3s;
      text-align: center;
      text-decoration: none;
      color: inherit;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .choice-option:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    }

    .member-option {
      border-color: #E5332A;
      background: linear-gradient(135deg, #fff5f5, #fff);
    }

    .member-option:hover {
      border-color: #c72a22;
      box-shadow: 0 8px 24px rgba(229, 51, 42, 0.2);
    }

    .guest-option {
      border-color: #3b82f6;
      background: linear-gradient(135deg, #f0f9ff, #fff);
    }

    .guest-option:hover {
      border-color: #2563eb;
      box-shadow: 0 8px 24px rgba(59, 130, 246, 0.2);
    }

    .option-icon {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
    }

    .member-option .option-icon {
      background: linear-gradient(135deg, #E5332A, #c72a22);
      color: #fff;
    }

    .guest-option .option-icon {
      background: linear-gradient(135deg, #3b82f6, #2563eb);
      color: #fff;
    }

    .choice-option h3 {
      font-size: 24px;
      margin-bottom: 24px;
      color: #2B2B2B;
    }

    .benefits-list {
      list-style: none;
      text-align: left;
      margin-bottom: 32px;
      width: 100%;
    }

    .benefits-list li {
      padding: 10px 0;
      font-size: 15px;
      color: #495057;
      border-bottom: 1px solid #e9ecef;
    }

    .benefits-list li:last-child {
      border-bottom: none;
    }

    .action-btn {
      width: 100%;
      padding: 16px 32px;
      border-radius: 12px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      border: none;
      transition: all 0.3s;
    }

    .primary-action {
      background: #E5332A;
      color: #fff;
    }

    .primary-action:hover {
      background: #c72a22;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
    }

    .secondary-action {
      background: #3b82f6;
      color: #fff;
    }

    .secondary-action:hover {
      background: #2563eb;
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

    .guest-badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #e3f2fd;
      color: #1565c0;
      padding: 6px 12px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      margin-top: 16px;
    }

    .invoice-address-section {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 16px;
  margin-top: 24px;
  border: 2px solid #e9ecef;
}

.checkbox-option {
  margin-bottom: 0;
}

.checkbox-label-modern {
  display: block;
  cursor: pointer;
  user-select: none;
}

.checkbox-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  transition: all 0.2s;
}

.checkbox-content:hover {
  border-color: #E5332A;
  box-shadow: 0 2px 8px rgba(229, 51, 42, 0.1);
}

.checkbox-input {
  display: none;
}

.checkbox-icon {
  width: 24px;
  height: 24px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.2s;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-content .checkbox-icon {
  background: #E5332A;
  border-color: #E5332A;
  color: #fff;
}

.checkbox-empty {
  width: 12px;
  height: 12px;
}

.checkbox-text-wrapper {
  flex: 1;
}

.checkbox-title {
  display: block;
  font-weight: 700;
  font-size: 15px;
  color: #2B2B2B;
  margin-bottom: 4px;
}

.checkbox-description {
  display: block;
  font-size: 13px;
  color: #868e96;
  line-height: 1.4;
}

.invoice-address-form {
  margin-top: 24px;
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  border: 2px solid #e9ecef;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-header-small {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f3f5;
}

.form-header-small h4 {
  font-size: 16px;
  font-weight: 700;
  color: #2B2B2B;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-header-small p {
  font-size: 13px;
  color: #868e96;
  margin: 0;
}

.shipping-threshold-info {
  background: #fff5f5;
  border: 1px solid #ffe0e0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.shipping-threshold-info svg {
  color: #E5332A;
  flex-shrink: 0;
}

.shipping-threshold-info p {
  font-size: 13px;
  color: #495057;
  margin: 0;
  line-height: 1.5;
}

.shipping-threshold-info strong {
  color: #2B2B2B;
}

    @media (max-width: 992px) {
  .checkout-layout {
    grid-template-columns: 1fr;
  }
  
  .order-summary-sidebar {
    position: static;
    order: -1; /* Özet en üste çık */
  }
  
  /* ✅ Mobilde desktop yasal onayları gizle */
  .desktop-legal-section {
    display: none !important;
  }
  
  /* ✅ Mobilde mobil yasal onayları göster */
  .mobile-legal-section {
    display: block !important;
  }
  
  .progress-steps {
    overflow-x: auto;
    justify-content: flex-start;
    padding: 0 10px;
  }
  
  .invoice-type-selector {
    grid-template-columns: 1fr;
  }
  
  .payment-methods-selector {
    grid-template-columns: 1fr;
  }
  
  .checkout-section {
    padding: 20px;
    border-radius: 16px;
  }
  
  .section-header h2 {
    font-size: 20px;
  }
  
  .step-circle {
    width: 44px;
    height: 44px;
  }
  
  .progress-step span {
    font-size: 12px;
  }
  
  .progress-line {
    max-width: 80px;
    margin: 0 10px;
  }

  .choice-buttons {
        grid-template-columns: 1fr;
        gap: 24px;
      }

      .prompt-card {
        padding: 32px 24px;
      }

      .prompt-card h2 {
        font-size: 24px;
      }

      .shipping-threshold-info {
    padding: 12px;
  }
  
  .shipping-threshold-info p {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .checkout-section {
    padding: 16px;
  }
  
  .address-type-selector {
    flex-direction: column;
  }
  
  .checkout-actions {
    flex-direction: column;
  }
  
  .back-btn,
  .continue-btn {
    width: 100%;
  }
  
  .invoice-type-card {
    padding: 16px;
  }
  
  .type-icon {
    width: 40px;
    height: 40px;
  }
  
  .breadcrumb {
    font-size: 13px;
    margin: 16px 0;
  }
  
  /* Mobil için yasal onaylar bölümü vurgusu */
  .legal-consents-section {
    border-width: 3px;
    box-shadow: 0 4px 12px rgba(229, 51, 42, 0.15);
  }

  .login-prompt-section {
        padding: 32px 0;
      }

      .choice-option {
        padding: 32px 24px;
      }

      .option-icon {
        width: 64px;
        height: 64px;
      }

      .choice-option h3 {
        font-size: 20px;
      }

      .benefits-list li {
        font-size: 14px;
      }

      .invoice-address-section {
    padding: 16px;
  }
  
  .checkbox-content {
    flex-direction: row;
    align-items: flex-start;
  }
  
  .checkbox-title {
    font-size: 14px;
  }
  
  .checkbox-description {
    font-size: 12px;
  }
  
  .invoice-address-form {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .legal-section-header h3 {
    font-size: 16px;
  }
  
  .consent-text {
    font-size: 12px;
  }
  
  .legal-link {
    font-size: 12px;
  }
  
  .order-number-box {
    padding: 20px;
  }
  
  .summary-card {
    padding: 16px;
  }
}
  `}</style>;
}